/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for OmHookCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions } from "../models";

@Injectable({ providedIn: "root" })
export class OmHookCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    omHook7(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook7(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook7(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook7(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook8(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook8(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook8(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook8(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook9(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook9(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook9(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook9(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook11(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook11(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook11(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook11(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: requestBody,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook10(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook10(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook10(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook10(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook13(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook13(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook13(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook13(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('options', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    omHook12(requestBody: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    omHook12(requestBody: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    omHook12(requestBody: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    omHook12(requestBody: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/hooks/omsn`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('head', url, {
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
